// extracted by mini-css-extract-plugin
module.exports = {"link":"footer-module--link--2w0EQ"};